import { render, staticRenderFns } from "./DraftOfferChangeRequest.vue?vue&type=template&id=affb415e&"
import script from "./DraftOfferChangeRequest.vue?vue&type=script&lang=js&"
export * from "./DraftOfferChangeRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports